<span [formGroup]="form">
  <mat-form-field appearance="outline">
    <mat-label [class.disabled]="isDisabled">{{ label }}</mat-label>
    <input
      [readonly]="readonly"
      matInput
      [formControl]="formControl"
      [specialCharacters]="['x', '-', '(', ')', ' ']"
      mask="(000) 000 - 0000 x 999999"
    />
    <mat-error>
      <app-boomer-forms-errors [control]="formControl"></app-boomer-forms-errors>
    </mat-error>
    <mat-icon [class.disabled]="isDisabled" matSuffix *ngIf="readonly === undefined">phone</mat-icon>
    <mat-icon [class.disabled]="isDisabled" *ngIf="readonly !== undefined" matSuffix>lock</mat-icon>
  </mat-form-field>
</span>
